import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-12 md:grid-cols-8 grid-cols-1 gap-4 w-full items-center py-4 my-0" }
const _hoisted_2 = { class: "md:col-span-3 col-span-12 flex flex-row md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Nome:", -1)
const _hoisted_4 = { class: "md:text-left truncate" }
const _hoisted_5 = { class: "md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "CRM:", -1)
const _hoisted_7 = { class: "md:col-span-1 col-span-6 flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "UF:", -1)
const _hoisted_9 = { class: "md:col-span-2 col-span-12 flex flex-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Inserido em:", -1)
const _hoisted_11 = { class: "md:col-span-3 col-span-6 flex flex-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Por:", -1)
const _hoisted_13 = { class: "md:col-span-2 col-span-12 flex flex-row justify-start md:justify-start gap-8 mt-4 md:mt-0" }

import { ref } from 'vue'

import { mdiPlaylistRemove } from '@mdi/js'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import { useErrorToast } from '@/composables/useErrorToast'

import UserDisplay from '../AvatarUser/index.vue'
import ConfirmAlert from '@/components/designSystem/Alerts/ConfirmAlert.vue'

interface BlockedDoctorDisplayData {
  id: number
  name: string
  crm: string
  crmUf: string
  insertedAt: string
  insertedBy: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TableBlockedDsPolicies',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;



const showModal = ref(false)
const showModalKey = ref(0)
const isLoading = ref(false)
const selectedDoctor = ref<{ id: number; name: string }>({ id: 0, name: '' })

const modalTitle = ref('')
const modalDescription = ref('')
const policyStore = useDsPolicyStore()
const { notifyError } = useErrorToast()

const openModal = (id: number, name: string) => {
  selectedDoctor.value = { id, name }
  modalTitle.value = 'Confirmar a remoção'
  modalDescription.value = `Você tem certeza que deseja remover ${name} da lista de bloqueados?`
  showModalKey.value++
  showModal.value = true
}

const handleConfirm = async () => {
  // Validação local ANTES do try: um `throw` aqui dentro cairia no `notifyError` e
  // apareceria como falha de API ("não foi possível remover...").
  const policyId = policyStore.currentPolicy?.id
  if (!policyId) {
    console.error('Policy ID não encontrado')
    return
  }

  isLoading.value = true

  try {
    await policyStore.deleteBlockedDoctor(selectedDoctor.value.id)
  } catch (err) {
    notifyError(err, 'Não foi possível remover o médico da lista de bloqueados.')
    isLoading.value = false
    return
  }

  showModal.value = false

  try {
    await policyStore.fetchBlockedDoctorsByDsPolicy(policyId)
  } catch (err) {
    notifyError(err, 'Não foi possível atualizar a lista de médicos bloqueados.')
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.data.name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.crm), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.crmUf), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(_ctx.data.insertedAt), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(UserDisplay, {
            name: _ctx.data.insertedBy
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_v_icon, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(_ctx.data.id, _ctx.data.name))),
            class: "share-icon hover:cursor-pointer",
            color: "negative",
            icon: _unref(mdiPlaylistRemove)
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(ConfirmAlert, {
      key: showModalKey.value,
      showAlert: showModal.value,
      title: modalTitle.value,
      message: modalDescription.value,
      loading: isLoading.value,
      onOnCancel: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false)),
      onOnConfirm: handleConfirm
    }, null, 8, ["showAlert", "title", "message", "loading"]))
  ], 64))
}
}

})